import articulus from './articulus'
import { getFechaMesCortoComaAnio } from './utiles'
import { setIdiomas, urlBaseApi, obtenerSrcset } from './comun'

export function iniciar (plantilla, contenedor, opciones, cb) {
  const op = {
    api: opciones.api || '', // 'full', 'light' o vacío
    cache: opciones.cache === 1 ? 1 : 0,
    idioma: opciones.idioma && setIdiomas.includes(opciones.idioma) ? opciones.idioma : setIdiomas[0],
    seccion: opciones.seccion || '', // Nombre base
    orden: opciones.orden || 'crono',
    ordenDir: opciones.ordenDir || 'desc',
    cantidad: parseInt(opciones.cantidad, 10) || 6,
    pagina: parseInt(opciones.pagina, 10) || 1,
    categoria: opciones.categoria || '', // Nombre base
    etiqueta: opciones.etiqueta || '', // Nombre base
    busqueda: opciones.busqueda || '',
    excluir: opciones.excluir || '', // Título base
    rutaEnlace: opciones.rutaEnlace || '',
    incCategorias: opciones.incCategorias || 0,
    incEtiquetas: opciones.incEtiquetas || 0
  }
  if (op.seccion === '') {
    console.error(new Error('No se pudieron recuperar los artículos. Falta la sección.'))
    return
  }
  const artiExtra = op.excluir ? 1 : 0
  op.api = op.api ? '-' + op.api : ''
  const url = `${urlBaseApi}/apis/articulus/v1/blogs/${op.seccion}/articulos${op.api}/?orden=${op.orden}&ordenDir=${op.ordenDir}&pag=${op.pagina}&porPag=${op.cantidad + artiExtra}&categoria=${op.categoria}&etiqueta=${op.etiqueta}&busqueda=${op.busqueda}&incEtiquetas=${op.incEtiquetas}&incCategorias=${op.incCategorias}&cache=${op.cache}`
  const aLibros = [
    "charlas_con_mi_hemisferio_derecho",
    "el_mejor_infarto_de_mi_vida",
    "el_nuevo_paraiso_de_los_tontos",
    "el_pibe_que_arruinaba_las_fotos",
    "espana_deci_alpiste",
    "los_consejos_de_mi_abuelo_facho",
    "mas_respeto_que_soy_tu_madre",
    "messi_es_un_perro_y_otros_cuentos",
    "renuncio",
    "seis_meses_haciendome_el_loco",
    "todos_los_desechos_reservados"
  ]
  articulus(url, op.idioma).then(artis => {
    mostrarArticulos(artis)
  }).catch(error => { console.log(error) })

  function mostrarArticulos (artis) {
    if (artis.articulos.length > 0) {
      let agregados = 0
      artis.articulos.forEach(arti => {
        if (arti.tituloUrl !== op.excluir && agregados < op.cantidad) {
          const articulo = plantilla.cloneNode(true) // Clona plantilla
          if (articulo.querySelector('.copete')) {
            articulo.querySelector('.copete').textContent = arti.copete // Agrega datos a la plantilla
          }
          if (articulo.querySelector('.titulo')) {
            articulo.querySelector('.titulo').textContent = arti.titulo
          }
          if (articulo.querySelector('.fecha')) {
            const [diaMes, anio] = getFechaMesCortoComaAnio(arti.fechaPublicado, op.idioma).split(', ')
            const fechaHtml = diaMes + ', <span class="anio">' + anio + '</span>'
            articulo.querySelector('.fecha').innerHTML = fechaHtml
            articulo.querySelector('.fecha').setAttribute('datetime', arti.fechaPublicado.substr(0, 10))
          }
          if (articulo.querySelector('.comentarios')) {
            articulo.querySelector('.comentarios').textContent = arti.comentarios
            if (arti.comentarios === 0) {
              articulo.querySelector('.comentarios').parentNode.classList.add('oculto')
            }
          }
          if (articulo.querySelector('.autor')) {
            articulo.querySelector('.autor').textContent = arti.autor
          }
          if (articulo.querySelector('.imagen img') && arti.imgPrincipal) {
            // Agrega propiedades src srcset y alt a la imagen
            articulo.querySelector('.imagen img').src = urlBaseApi + arti.imgPrincipal
            articulo.querySelector('.imagen img').srcset = obtenerSrcset(urlBaseApi + arti.imgPrincipal)
            articulo.querySelector('.imagen img').alt = arti.titulo
          }
          if (articulo.querySelector('.entradilla')) {
            articulo.querySelector('.entradilla').innerHTML = arti.entradilla
          }
          // Libros
          if (articulo.querySelector('.libros') && arti.nombresCate) {
            const aNombresCate = arti.nombresCate.split('<->')
            const nombresBaseCate = arti.nombresBaseCate.split(',')
            nombresBaseCate.forEach((nbc, i) => {
              if (aLibros.includes(nbc)) { // Es un libro
                let clonLibro = document.querySelector('.plantilla.libro').cloneNode(true)
                clonLibro.classList.add(nbc)
                clonLibro.querySelector('.libroTooltip').textContent = aNombresCate[i]
                clonLibro.href = `/blog/categoria/${nbc}`
                articulo.querySelector('.libros').appendChild(clonLibro)
                clonLibro.classList.remove('plantilla')
              }
            })
          }
          // Etiquetas
          const conIdioma = setIdiomas.includes(document.location.pathname.split('/')[1]) // Hay idioma en URL
          if (articulo.querySelector('.etiquetas') && arti.nombresEtiq) {
            const idiomaEtiq = {
              es: 'etiqueta',
              en: 'tag',
              ca: 'etiqueta',
              fr: 'etiquette',
              pt: 'rotulo'
            }
            const nombresEtiq = arti.nombresEtiq.split(',')
            const nombresBaseEtiq = arti.nombresBaseEtiq.split(',')
            const cantidadArtisEtiq = arti.cantidadArtisEtiq.split(',')
            let aEtiquetas = []
            for (let i = 0; i < nombresEtiq.length; i++) { // Pone datos de etiquetas en un solo array
              aEtiquetas.push({ nombre: nombresEtiq[i], nombreBase: nombresBaseEtiq[i], cantidadArtis: parseInt(cantidadArtisEtiq[i], 10) })
            }
            aEtiquetas.sort((a,b) => { // Ordena etiquetas por cantidad de artículos descendente
              return (a.cantidadArtis < b.cantidadArtis) ? 1 : ((b.cantidadArtis < a.cantidadArtis) ? -1 : 0)
            })
            let etiqHref
            let etiquetas = ''
            let etiqValidas = 0 // Con más de un artículo
            for (let i = 0; i < aEtiquetas.length; i++) {
              if (aEtiquetas[i].cantidadArtis > 1) {
                etiqHref = conIdioma 
                  ? `/${op.idioma}/blog/${idiomaEtiq[op.idioma]}/${aEtiquetas[i].nombreBase}` 
                  : `/blog/${idiomaEtiq[op.idioma]}/${aEtiquetas[i].nombreBase}`
                etiquetas += `<a href="${etiqHref}"><span class="nombresEtiq">${aEtiquetas[i].nombre}</span><span class="cantidadArtisEtiq">${aEtiquetas[i].cantidadArtis}</span></a>`
                etiqValidas ++
              }
              if (etiqValidas > 5) break // Se muestran hasta 6 etiquetas
            }
            articulo.querySelector('.etiquetas').innerHTML = etiquetas
          }
          //
          const enlaces = articulo.querySelectorAll('.enlace')
          let enlaceHref
          for (const enlace of enlaces) {
            if (op.rutaEnlace) {
              enlaceHref = op.rutaEnlace + arti.tituloUrl
            } else {
              enlaceHref = `/blog/${arti.tituloUrl}`
            }
            if (conIdioma) {
              enlaceHref = `/${op.idioma}${enlaceHref}`
            }
            enlace.href = enlaceHref
          }
          contenedor.appendChild(articulo) // Agrega plantilla al contenedor
          articulo.classList.remove('plantilla') // y la hace visible
          agregados++
        }
      })
    }
    // Callback
    if (typeof cb === 'function') cb(artis)
  }
}
